// src/components/UpdateModal.jsx
import { useAppUpdate } from 'views/root/AppUpdateProvider';
import logger from 'utils/logger';
import { Typography, Button, Modal, Card } from '@mui/material';
import intl from 'react-intl-universal';

const log = logger.createLogger('UpdateModal');

const UpdateModal = () => {
  const { isUpdateAvailable } = useAppUpdate();

  if (!isUpdateAvailable) {
    return null;
  }

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <Modal
      open={isUpdateAvailable}
      onClose={(event, reason) => {
        // Only allow closing via the refresh button, not backdrop click or escape key
        if (reason === 'refreshButton') {
          handleRefresh();
        }
      }}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'scroll',
      }}>
      <Card sx={{ margin: 4, marginTop: 3, width: 800, padding: '30px 40px' }}>
        <Typography variant="h3" sx={{ marginBottom: 2 }}>
          {intl.get('shared_update_available')}
        </Typography>
        <Typography variant="subtitle1" sx={{ marginBottom: 2 }}>
          {intl.get('shared_update_available_description')}
        </Typography>
        <Button variant="contained" color="info" onClick={handleRefresh}>
          {intl.get('shared_update_available_button')}
        </Button>
      </Card>
    </Modal>
  );
};

export default UpdateModal;
